import { useState, MouseEvent } from "react";

import "./AutoCompleteInput.scss";

type OptionType = (string | null | undefined)[];

type AutoCompleteResultListProps = {
  onItemSelected: (index: number) => void;
  options: OptionType[];
  selectedIndex: number;
};

export default function AutoCompleteResultList({
  onItemSelected,
  options,
  selectedIndex
}: AutoCompleteResultListProps) {
  const [hoverIndex, setHoverIndex] = useState<number>(-1);

  const handleMouseEnter = (index: number) => {
    setHoverIndex(index);
  };

  const handleMouseLeave = () => {
    setHoverIndex(-1);
  };

  const handleClick = (index: number) => {
    onItemSelected(index);
  };

  const handleMouseDown = (e: MouseEvent<HTMLUListElement>) => {
    e.preventDefault(); // Prevent input blur on click
  };

  const itemClass = (index: number) => {
    const isSelected = index === selectedIndex;
    const isMarked = index === hoverIndex;

    return `listItem ${
      isSelected ? "selectedItem" : isMarked ? "markedItem" : ""
    }`;
  };

  const itemText = (option: any) => {
    // If each option is an array (like [["A", "B"]]), this works
    return option.map((value: any, i: number) => <div key={i}>{value}</div>);
  };

  return (
    <ul onMouseDown={handleMouseDown} onMouseLeave={handleMouseLeave}>
      {options.map((option, index) => (
        <li
          key={index}
          onClick={() => handleClick(index)}
          onMouseEnter={() => handleMouseEnter(index)}
          className={itemClass(index)}
        >
          {itemText(option)}
        </li>
      ))}
    </ul>
  );
}
